<template>
  <button
    :class="buttonClasses"
    :type="type"
    :disabled="disabled"
    @click="$emit('click', $event)"
  >
    <slot name="icon-left"></slot>
    <span v-if="$slots.default" :class="textClasses">
      <slot></slot>
    </span>
    <slot name="icon-right"></slot>
  </button>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  variant: {
    type: String,
    default: "primary",
    validator: (value) =>
      [
        "primary",
        "secondary",
        "success",
        "warning",
        "error",
        "outline",
      ].includes(value),
  },
  size: {
    type: String,
    default: "md",
    validator: (value) => ["xs", "sm", "md", "lg", "xl"].includes(value),
  },
  rounded: {
    type: Boolean,
    default: false,
  },
  fullWidth: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: "button",
  },
});

const emit = defineEmits(["click"]);

const buttonClasses = computed(() => {
  const base = "btn";
  const variants = {
    primary: "btn-primary",
    secondary: "btn-secondary",
    success: "btn-primary",
    warning: "btn-warning",
    error: "btn-error",
    outline: "btn-outline",
  };
  const sizes = {
    xs: "px-2 py-1 text-xs",
    sm: "px-3 py-1.5 text-sm",
    md: "px-4 py-2 text-sm",
    lg: "px-6 py-3 text-base",
    xl: "px-8 py-4 text-lg",
  };
  const roundedClass = props.rounded ? "rounded-full" : "";
  const widthClass = props.fullWidth ? "w-full" : "";
  const disabledClass = props.disabled ? "opacity-50 cursor-not-allowed" : "";

  return [
    base,
    variants[props.variant],
    sizes[props.size],
    roundedClass,
    widthClass,
    disabledClass,
  ].join(" ");
});

const textClasses = computed(() => {
  return props.size === "xs" || props.size === "sm" ? "ml-1" : "ml-2";
});
</script>
